const config = {
  defaultPage: '/dashboard',
  workspace: {
    paymentInfoEnable: false,
    downloadCSVEnable: true,
    editWorkspaceEnable: true,
    addWorksapceEnable: true,
    addMemberEnable: false,
    maxMemberEditable: true,
    expiredAtEditable: true,
    statusEditable: true,
  },
}

export default config
